import { IELTPopulatedData } from 'legacy/lut/classes/models/partner360/ELT/IELTPopulatedData'

export const INITIAL_POPULATED_DATA: IELTPopulatedData = {
  Employees: 'XXX',
  BriefDescription: 'XXX',
  Revenue: 'XXX',
  TAM: 'XXX',
  Markets: '',
  SoldProducts: '',
  HQLocation: 'XXX',
  LastELTEngagement: '',
}
